import { ContentPasteOffSharp } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Trans } from 'react-i18next';

function NameDialog({ open, onClose, onSave, title, description, name }) {
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(name)
    }, [name])

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(value);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                component: 'form',
                onSubmit: handleSubmit
            }}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {description}
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    name="Name"
                    label="Name"
                    fullWidth
                    variant="standard"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}><Trans i18nKey="abbrechen" ns="instituteConfigurationPage">Abbrechen</Trans></Button>
                <Button onClick={handleSubmit} variant="contained" type="submit"><Trans i18nKey="speichern" ns="instituteConfigurationPage">Speichern</Trans></Button>
            </DialogActions>
        </Dialog>
    );
};

export default NameDialog
